( function( $ ) {

    /*aos*/
    // власний тригер замість AOS.init(): AOS рахує позиції через offsetTop/scrollY, і з body { zoom: 0.8 } (1200–1446px)
    // анімації спрацьовують невчасно. IntersectionObserver від zoom не залежить. Стилі aos.css і атрибути data-aos — ті самі.
    $(document).ready(function () {
        var els = document.querySelectorAll('[data-aos]');
        document.body.setAttribute('data-aos-easing', 'ease');
        document.body.setAttribute('data-aos-duration', '400');
        document.body.setAttribute('data-aos-delay', '0');
        els.forEach(function (el) { el.classList.add('aos-init'); });
        if (!('IntersectionObserver' in window)) {
            els.forEach(function (el) { el.classList.add('aos-animate'); });
            return;
        }
        var aosObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('aos-animate');
                    aosObserver.unobserve(entry.target);
                }
            });
        }, {rootMargin: '0px 0px -120px 0px'});
        els.forEach(function (el) {
            // перший екран (напр. hero з overflow: hidden, де стартовий зсув fade-up ховає елемент) — показуємо одразу
            if (el.closest('.main-hero') || el.getBoundingClientRect().top < window.innerHeight) {
                el.classList.add('aos-animate');
            } else {
                aosObserver.observe(el);
            }
        });
    });
    /*aos*/

    /*input phone*/
    $('input[type="text"].js-phnInp').on('input', function() {
        this.value = this.value.replace(/[^0-9\+]/g, '');
    });
    /*input phone*/

    /*desktop/mob link change*/
    $(window).on('load resize', function(){
        $('[href^="tel:"]').each(function(){
            var $this = $(this);
            var tag = '';
            if ($(window).width() > 991) {
                // e.preventDefault();
                tag = '<span>';
            } else {
                tag = '<a>';
            }
            var $span = $(tag).html($this.html());
            $.each(this.attributes, function() {
                $span.attr(this.name, this.value);
            });
            $this.replaceWith($span);
        });
    });
    /*desktop/mob link change*/

    /*header*/
    $(window).scroll(function(){
        var hHeight = $('.js-header').outerHeight();
        if ($(window).scrollTop() > hHeight) {
            $('.js-header').addClass('fixed');
        } else {
            $('.js-header').removeClass('fixed');
        }
    });
    /*header*/

    /*header menu*/
    $('.js-hMenuBtn').click(function(){
        $(this).toggleClass('active');
        $(this).attr('aria-expanded', $(this).hasClass('active'));
        $('.js-header').toggleClass('menu-opened', $(this).hasClass('active'));
        $('body').toggleClass('h-menu-opened', $(this).hasClass('active'));
        $('.js-hMenu').slideToggle();
    });

    // повернення на десктоп: прибираємо inline-стилі slideToggle і стан мобільного меню
    $(window).on('resize', function () {
        if ($(window).width() > 1199) {
            $('.js-hMenu, .js-hMenu .sub-menu').removeAttr('style');
            $('.js-hMenuBtn, .js-hMenuArr').removeClass('active clicked').attr('aria-expanded', 'false');
            $('.js-hMenu li').removeClass('opened');
            $('.js-header').removeClass('menu-opened');
            $('body').removeClass('h-menu-opened');
        }
    });


    $('.js-hMenu').click(function(e) {
        e.stopPropagation();
    });
    $('.js-hMenu ul li a').click(function(e) {
        if ($(window).width() < 1200) {
            $('.js-hMenuBtn').removeClass('active').attr('aria-expanded', 'false');
            $('.js-header').removeClass('menu-opened');
            $('body').removeClass('h-menu-opened');
            $('.js-hMenu').slideUp();
        }
    });

    $('.js-hMenuArr').click(function(e) {
        var $li = $(this).closest('li');
        $(this).toggleClass('clicked');
        $li.toggleClass('opened');
        $(this).attr('aria-expanded', $li.hasClass('opened'));
        // мобайл/планшет — акордеон; десктоп — дропдаун показує CSS (.opened / :focus-within)
        if ($(window).width() < 1200) $(this).siblings('.sub-menu').slideToggle();
    });
    // десктоп: підменю, відкрите з клавіатури, закривається на Esc і коли фокус виходить за межі пункту
    function hMenuClose($li, focusArrow) {
        var $arr = $li.removeClass('opened').children('.js-hMenuArr').removeClass('clicked').attr('aria-expanded', 'false');
        if (focusArrow) $arr.trigger('focus');
    }
    $('.js-hMenu').on('keydown', function (e) {
        if (e.key !== 'Escape' || $(window).width() < 1200) return;
        var $li = $(e.target).closest('li.opened');
        if ($li.length) hMenuClose($li, true);
    });
    $('.js-hMenu').on('focusout', '.menu > li.opened', function (e) {
        if ($(window).width() < 1200) return;
        var li = this;
        setTimeout(function () { if (!li.contains(document.activeElement)) hMenuClose($(li), false); }, 0);
    });
    /*header menu*/

    /*modal contact*/
    // відкривається будь-яким посиланням на «#modal» (пункти меню, кнопки, віджети) або .js-modlBtn
    $(document).on('click', '.js-modlBtn, a[href="#modal"], a[href$="/#modal"]', function(e){
        e.preventDefault();
        $('.js-hMenuBtn.active').trigger('click');
        $('.js-modalWindow').addClass('active');
        $('body').css('overflow', 'hidden');
        setTimeout(function () { $('.js-modalWindow').find('input, select, textarea').filter(':visible').first().trigger('focus'); }, 300);
    });
    $('.js-modalWindowCls').click(function(){
        $('.js-modalWindow').removeClass('active');
        $('body').css('overflow', '');
    });
    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') $('.js-modalWindow.active .js-modalWindowCls, .js-modalContact.active .js-modalContactCls').first().trigger('click');
    });
    /*modal contact*/

    /*modal parking*/
    // pop-up « Info parking » (accueil, bloc Accès) : déplacée hors de <main> pour passer au-dessus de l'en-tête
    var $parkingModal = $('.js-modalParking');
    if ($parkingModal.length) {
        $parkingModal.appendTo('body');
        var parkingReturn = null;
        $(document).on('click', '.js-parkingBtn', function () {
            parkingReturn = this;
            $parkingModal.addClass('active');
            $('body').css('overflow', 'hidden');
            setTimeout(function () { $parkingModal.find('.modal-window-cls').trigger('focus'); }, 50);
        });
        $(document).on('click', '.js-modalParkingCls', function () {
            $parkingModal.removeClass('active');
            $('body').css('overflow', '');
            if (parkingReturn) $(parkingReturn).trigger('focus');
        });
        $(document).on('keydown', function (e) {
            if (e.key === 'Escape' && $parkingModal.hasClass('active')) $parkingModal.find('.modal-window-cls').trigger('click');
        });
    }
    /*modal parking*/

    /*h-side phone*/
    // widget téléphone avec deux numéros : clic (ou Entrée) pour les afficher, en plus du survol
    $('.js-hSidePhn').on('click', function (e) {
        if ($(e.target).closest('a').length) return;
        var open = !$(this).hasClass('open');
        $(this).toggleClass('open', open).attr('aria-expanded', open ? 'true' : 'false');
    }).on('keydown', function (e) {
        if ((e.key === 'Enter' || e.key === ' ') && e.target === this) {
            e.preventDefault();
            $(this).trigger('click');
        }
        if (e.key === 'Escape') $(this).removeClass('open').attr('aria-expanded', 'false');
    });
    $(document).on('click', function (e) {
        if (!$(e.target).closest('.js-hSidePhn').length) $('.js-hSidePhn.open').removeClass('open').attr('aria-expanded', 'false');
    });
    /*h-side phone*/

    /*video*/
    $(document).ready(function () {
        const player = $('.js-heroVideo')[0];
        if (!player) return;
        // відео в hero не зупиняється: якщо браузер поставив на паузу (енергозбереження, вкладка у фоні) — запускаємо знову
        player.addEventListener('pause', function () {
            setTimeout(function () { player.play().catch(function () {}); }, 300);
        });
        document.addEventListener('visibilitychange', function () {
            if (!document.hidden) player.play().catch(function () {});
        });
        $('.js-firstLoud').on('click', function () {
            const $this = $(this);
            player.muted = !player.muted;
            $this.find('.sound').removeClass('active');
            $this.find('.sound[data-sound="' + (player.muted ? 'disabled' : 'enabled') + '"]').addClass('active');
        });
    });
    /*video*/

    /*split lines H1/H2*/
    function splitLines(el) {
        var $el = $(el);
        if (!$el.data('orig')) $el.data('orig', $el.html());
        $el.html($el.data('orig'));
        // розбиваємо текстові вузли на слова, <br> лишаємо; вкладені елементи (напр. <b class="brand-ortho">) — теж «слова»
        $el.contents().each(function () {
            if (this.nodeType === 3) {
                var html = this.nodeValue.split(/(\s+)/).map(function (w) {
                    return /^\s+$/.test(w) || w === '' ? w : '<span class="word">' + w.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</span>';
                }).join('');
                $(this).replaceWith(html);
            } else if (this.nodeType === 1 && this.tagName !== 'BR') {
                $(this).wrap('<span class="word"></span>');
            }
        });
        // слова без пробілу між ними (<b>ORTHO</b>Care) склеюємо в одне
        var lines = [], top = null, prev = null;
        $el.children('.word').each(function () {
            var t = this.offsetTop;
            var glued = prev !== null && prev.nextSibling === this;
            if (top === null || (Math.abs(t - top) > 2 && !glued)) { lines.push([]); top = t; }
            var line = lines[lines.length - 1];
            if (glued && line.length) line[line.length - 1] += this.innerHTML; else line.push(this.innerHTML);
            prev = this;
        });
        $el.html(lines.map(function (l) {
            return '<span class="line"><span class="line-in">' + l.join(' ') + '</span></span>';
        }).join(''));
        $el.find('.line-in').each(function (i) {
            this.style.transitionDelay = (i * 0.12) + 's';
        });
    }

    var splitObserver = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                $(entry.target).addClass('is-visible');
                splitObserver.unobserve(entry.target);
            }
        });
    }, {threshold: 0.2}) : null;

    $(window).on('load', function () {
        $('.js-splitLines').each(function () {
            splitLines(this);
            if (splitObserver) splitObserver.observe(this); else $(this).addClass('is-visible');
        });
    });

    var splitTimer;
    $(window).on('resize', function () {
        clearTimeout(splitTimer);
        splitTimer = setTimeout(function () {
            $('.js-splitLines').each(function () { splitLines(this); });
        }, 200);
    });
    /*split lines H1/H2*/

    /*main-vals*/
    $('.js-mainValsTab').on('click', function () {
        var $box = $(this).closest('.js-mainVals');
        var index = $(this).data('index');
        $box.find('.js-mainValsTab, .js-mainValsItem, .js-mainValsImg').removeClass('active');
        $box.find('[data-index="' + index + '"]').addClass('active');
    });
    /*main-vals*/

    /*main-parc*/
    // десктоп — ховер, тач — клік; стан лишається на останньому вибраному етапі
    $('.js-mainParcStep').on('mouseenter click', function () {
        var $wrap = $(this).closest('.js-mainParc');
        var index = $(this).data('index');
        $wrap.find('.js-mainParcStep, .js-mainParcItem, .js-mainParcImg').removeClass('active');
        $wrap.find('[data-index="' + index + '"]').addClass('active');
    });
    /*main-parc*/

    /*main-traits*/
    // десктоп: велика картка — та, на яку навели; після виходу з ряду повертається перша.
    // мобайл: при скролі велика картка — та, що ближче до центру екрана.
    function mainTraitsSet($list, $bl) {
        if ($bl.hasClass('active')) return;
        $list.find('.js-mainTraitsBl').removeClass('active');
        $bl.addClass('active');
    }
    $('.js-mainTraits').each(function () {
        var $list = $(this);
        var $items = $list.find('.js-mainTraitsBl');
        $items.on('mouseenter', function () {
            if ($(window).width() > 991) mainTraitsSet($list, $(this));
        });
        $list.on('mouseleave', function () {
            if ($(window).width() > 991) mainTraitsSet($list, $items.eq(0));
        });
    });
    var mainTraitsTick = false;
    $(window).on('scroll resize load', function () {
        if (mainTraitsTick) return;
        mainTraitsTick = true;
        window.requestAnimationFrame(function () {
            mainTraitsTick = false;
            if ($(window).width() > 991) return;
            var center = $(window).height() / 2;
            $('.js-mainTraits').each(function () {
                var $list = $(this), best = null, dist = Infinity;
                $list.find('.js-mainTraitsBl').each(function () {
                    var r = this.getBoundingClientRect();
                    var d = Math.abs(r.top + r.height / 2 - center);
                    if (d < dist) { dist = d; best = this; }
                });
                if (best) mainTraitsSet($list, $(best));
            });
        });
    });
    /*main-traits*/

    /*main-parallax*/
    // поява фото «лініями» + легкий паралакс фону
    var $parallax = $('.js-mainParallax');
    if ($parallax.length) {
        if ('IntersectionObserver' in window) {
            var parallaxObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        $(entry.target).addClass('is-visible');
                        parallaxObserver.unobserve(entry.target);
                    }
                });
            }, {threshold: 0.3});
            $parallax.each(function () { parallaxObserver.observe(this); });
        } else {
            $parallax.addClass('is-visible');
        }

        var parallaxTick = false;
        $(window).on('scroll resize load', function () {
            if (parallaxTick) return;
            parallaxTick = true;
            window.requestAnimationFrame(function () {
                parallaxTick = false;
                var wh = $(window).height();
                $parallax.each(function () {
                    var r = this.getBoundingClientRect();
                    if (r.bottom < 0 || r.top > wh) return;
                    // -1 (секція внизу екрана) … 1 (секція вгорі)
                    var progress = 1 - (r.top + r.height) / (wh + r.height) * 2;
                    $(this).find('.js-mainParallaxImg').css('--parallax-y', (progress * 8).toFixed(2) + '%');
                });
            });
        });
    }
    /*main-parallax*/

    /*main-cons*/
    var mainConsArrow = '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M1 1L7 7L1 13" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    // слайдер лише до 767px; на десктопі — звичайна сітка 3 колонки
    function mainConsSliders() {
        $('.js-mainConsSlider').each(function () {
            var $slider = $(this);
            var mobile = $(window).width() < 768;
            if (mobile && !$slider.hasClass('slick-initialized')) {
                var $btm = $slider.siblings('.js-mainConsSliderBtm');
                $slider.slick({
                    slidesToShow: 1,
                    arrows: true,
                    dots: true,
                    adaptiveHeight: true,
                    prevArrow: '<button type="button" class="main-cons-arrow prev" aria-label="Précédent">' + mainConsArrow + '</button>',
                    nextArrow: '<button type="button" class="main-cons-arrow next" aria-label="Suivant">' + mainConsArrow + '</button>',
                    appendArrows: $btm,
                    appendDots: $btm
                });
            } else if (!mobile && $slider.hasClass('slick-initialized')) {
                $slider.slick('unslick');
            }
        });
    }
    mainConsSliders();
    $(window).on('resize', mainConsSliders);

    $('.js-mainConsTab').on('click', function () {
        var $section = $(this).closest('section');
        var panel = String($(this).data('panel'));
        $section.find('.js-mainConsTab').removeClass('active');
        $(this).addClass('active');
        $section.find('.js-mainConsPanel').removeClass('active').filter(function () {
            return String($(this).data('panel')) === panel;
        }).addClass('active').find('.slick-initialized').slick('setPosition');
    });
    /*main-cons*/

    /*main-gal*/
    var mainGalArrow = '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M1 1L7 7L1 13" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    $('.js-mainGalSlider').each(function () {
        var $wrap = $(this).closest('.main-gal-slider-wrap');
        $(this).slick({
            slidesToShow: 1,
            centerMode: true,
            variableWidth: true,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 4000,
            pauseOnHover: true,
            pauseOnFocus: true,
            speed: 600,
            arrows: true,
            dots: true,
            prevArrow: '<button type="button" class="main-gal-arrow prev" aria-label="Précédent">' + mainGalArrow + '</button>',
            nextArrow: '<button type="button" class="main-gal-arrow next" aria-label="Suivant">' + mainGalArrow + '</button>',
            appendArrows: $wrap.find('.js-mainGalArrows'),
            appendDots: $wrap.find('.js-mainGalDots'),
            responsive: [{
                breakpoint: 992,
                settings: {centerMode: false, variableWidth: false, arrows: false}
            }]
        });
    });
    /*main-gal*/

    /*lightbox*/
    // agrandissement des photos : sliders de galerie (accueil, Le cabinet) et galeries de blocs (.wp-block-gallery)
    var lbArrow = '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M1 1L7 7L1 13" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var lbCross = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none"><path d="M1 1L19 19M19 1L1 19" stroke="currentColor" stroke-linecap="round"/></svg>';
    var $lb = null, lbItems = [], lbIndex = 0, lbReturn = null, lbSlider = null;
    function lbBuild() {
        if ($lb) return;
        $lb = $('<div class="lightbox" role="dialog" aria-modal="true" aria-label="Photo agrandie">' +
            '<button type="button" class="lightbox-cls" aria-label="Fermer">' + lbCross + '</button>' +
            '<button type="button" class="lightbox-arrow prev" aria-label="Photo précédente">' + lbArrow + '</button>' +
            '<figure class="lightbox-fig"><img class="lightbox-img" src="" alt=""></figure>' +
            '<div class="lightbox-count" aria-live="polite"></div>' +
            '<button type="button" class="lightbox-arrow next" aria-label="Photo suivante">' + lbArrow + '</button>' +
            '</div>').appendTo('body');
        $lb.on('click', '.lightbox-cls', lbClose);
        $lb.on('click', '.lightbox-arrow.prev', function () { lbShow(lbIndex - 1); });
        $lb.on('click', '.lightbox-arrow.next', function () { lbShow(lbIndex + 1); });
        $lb.on('click', function (e) {
            if (e.target === this || $(e.target).hasClass('lightbox-fig')) lbClose();
        });
        var lbX = null;
        $lb.on('touchstart', function (e) { lbX = e.originalEvent.touches[0].clientX; });
        $lb.on('touchend', function (e) {
            if (lbX === null) return;
            var dx = e.originalEvent.changedTouches[0].clientX - lbX;
            lbX = null;
            if (Math.abs(dx) > 50) lbShow(lbIndex + (dx < 0 ? 1 : -1));
        });
    }
    function lbShow(i) {
        var n = lbItems.length;
        if (!n) return;
        lbIndex = ((i % n) + n) % n;
        $lb.find('.lightbox-img').attr({src: lbItems[lbIndex].src, alt: lbItems[lbIndex].alt});
        $lb.find('.lightbox-count').text((lbIndex + 1) + ' / ' + n);
    }
    function lbOpen(items, index, trigger, $slider) {
        if (!items.length) return;
        lbBuild();
        lbItems = items;
        lbReturn = trigger || null;
        lbSlider = ($slider && $slider.hasClass('slick-initialized')) ? $slider : null;
        if (lbSlider) lbSlider.slick('slickPause');
        $lb.toggleClass('single', items.length < 2);
        lbShow(index);
        $lb.addClass('active');
        $('body').css('overflow', 'hidden');
        $lb.find('.lightbox-cls').trigger('focus');
    }
    function lbClose() {
        if (!$lb || !$lb.hasClass('active')) return;
        $lb.removeClass('active');
        $('body').css('overflow', '');
        if (lbSlider) lbSlider.slick('slickPlay');
        if (lbReturn) $(lbReturn).trigger('focus');
    }
    function lbItem(img) {
        var $img = $(img);
        var $a = $img.closest('a').filter(function () { return /\.(jpe?g|png|webp|gif|avif)(\?|$)/i.test(this.href); });
        return {src: $img.attr('data-full') || ($a.length ? $a.attr('href') : '') || img.currentSrc || img.src, alt: $img.attr('alt') || ''};
    }
    $(document).on('click', '.js-mainGalSlider .main-gal-slide-img img', function () {
        var $slider = $(this).closest('.js-mainGalSlider');
        var $orig = $slider.find('.main-gal-slide:not(.slick-cloned) .main-gal-slide-img img');
        var items = $orig.map(function () { return lbItem(this); }).get();
        var idx = parseInt($(this).closest('.main-gal-slide').attr('data-slick-index'), 10);
        if (isNaN(idx)) idx = $orig.index(this);
        lbOpen(items, idx, this, $slider);
    });
    $(document).on('click', '.wp-block-gallery img', function (e) {
        var $imgs = $(this).closest('.wp-block-gallery').find('img');
        e.preventDefault();
        lbOpen($imgs.map(function () { return lbItem(this); }).get(), $imgs.index(this), this);
    });
    $('.js-mainGalSlider .main-gal-slide:not(.slick-cloned) .main-gal-slide-img img, .wp-block-gallery img').attr({tabindex: '0', role: 'button'}).each(function () {
        $(this).attr('aria-label', 'Agrandir la photo' + ($(this).attr('alt') ? ' : ' + $(this).attr('alt') : ''));
    });
    $(document).on('keydown', '.js-mainGalSlider .main-gal-slide-img img, .wp-block-gallery img', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).trigger('click');
        }
    });
    $(document).on('keydown', function (e) {
        if (!$lb || !$lb.hasClass('active')) return;
        if (e.key === 'Escape') lbClose();
        else if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
        else if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
        else if (e.key === 'Tab') {
            var $f = $lb.find('button:visible');
            var i = $f.index(document.activeElement);
            e.preventDefault();
            $f.eq((i + (e.shiftKey ? -1 : 1) + $f.length) % $f.length).trigger('focus');
        }
    });
    /*lightbox*/

    /*page-cabinet*/
    // поява фото «лініями»
    var $revealLines = $('.js-revealLines');
    if ($revealLines.length) {
        if ('IntersectionObserver' in window) {
            var revealObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        $(entry.target).addClass('is-visible');
                        revealObserver.unobserve(entry.target);
                    }
                });
            }, {threshold: 0.25});
            $revealLines.each(function () { revealObserver.observe(this); });
        } else {
            $revealLines.addClass('is-visible');
        }
    }

    // «Notre façon de vous accueillir»: ПК — ховер міняє активний пункт і фото; мобайл — акордеон
    $('.js-cabAccueilItem').on('mouseenter', function () {
        if ($(window).width() < 992) return;
        var $wrap = $(this).closest('.js-cabAccueil');
        var index = $(this).data('index');
        $wrap.find('.js-cabAccueilItem, .js-cabAccueilImg').removeClass('active');
        $wrap.find('[data-index="' + index + '"]').addClass('active');
        cabAccueilImgPos($wrap);
    });
    // фото стоїть навпроти активного пункту, не виходячи за межі списку
    function cabAccueilImgPos($wrap) {
        var $img = $wrap.find('.page-cabinet-accueil-img');
        var $item = $wrap.find('.js-cabAccueilItem.active');
        if (!$img.length || !$item.length || $(window).width() < 992) { $img.css('top', ''); return; }
        var listH = $wrap.find('.page-cabinet-accueil-list').outerHeight();
        // offsetTop — у макетних px (на відміну від position(), не залежить від body { zoom })
        var top = Math.min($item[0].offsetTop, listH - $img.outerHeight());
        $img.css('top', Math.max(0, top));
    }
    $(window).on('load resize', function () {
        $('.js-cabAccueil').each(function () { cabAccueilImgPos($(this)); });
    });
    $('.js-cabAccueilHead').on('click', function () {
        if ($(window).width() > 991) return;
        var $item = $(this).closest('.js-cabAccueilItem');
        var $wrap = $item.closest('.js-cabAccueil');
        if ($item.hasClass('active')) return;
        $wrap.find('.js-cabAccueilItem.active').removeClass('active');
        $item.addClass('active');
    });

    // «Nos technologies»: ховер (ПК) / клік (тач) відкриває текст і міняє фото
    $('.js-cabTechsItem').on('mouseenter click', function (e) {
        if (e.type === 'mouseenter' && $(window).width() < 992) return;
        var $grid = $(this).closest('.js-cabTechs');
        var index = $(this).data('index');
        $grid.find('.js-cabTechsItem, .js-cabTechsImg').removeClass('active');
        $grid.find('[data-index="' + index + '"]').addClass('active');
    });

    // відео замість фото після кліку на «play»
    $('.js-cabVideoPlay').on('click', function () {
        var $box = $(this).closest('.js-cabVideo');
        $box.find('img').replaceWith('<video src="' + $box.data('video') + '" controls autoplay playsinline></video>');
        $(this).remove();
    });
    /*page-cabinet*/

    /*faq*/
    // ПК — ховер, тач — клік; активний пункт: заливка + відповідь; фото поруч (.js-faqImg) міняється
    $('.js-faqItem').on('mouseenter click', function (e) {
        if (e.type === 'mouseenter' && $(window).width() < 992) return;
        var $item = $(this);
        if ($item.hasClass('active')) return;
        var index = $item.data('index');
        $item.closest('.js-faq').find('.js-faqItem').removeClass('active');
        $item.addClass('active');
        var $wrap = $item.closest('.js-faqWrap');
        if ($wrap.length) {
            $wrap.find('.js-faqImg').removeClass('active');
            $wrap.find('.js-faqImg[data-index="' + index + '"]').addClass('active');
        }
    });
    /*faq*/

    /*page-parc*/
    // етапи: розгорнуті за замовчуванням, клік по заголовку згортає / розгортає
    $('.js-parcStepHead').on('click', function () {
        var $step = $(this).closest('.js-parcStep');
        $step.toggleClass('opened');
        $(this).attr('aria-expanded', $step.hasClass('opened'));
    });
    /*page-parc*/

    /*before-after*/
    $(document).on('input change', '.js-beforeAfterRange', function () {
        $(this).closest('.js-beforeAfter')[0].style.setProperty('--pos', this.value + '%');
    });
    /*before-after*/

    /*slider*/
    $('.js-sliderSlider').on("init reInit beforeChange", function(event, slick, currentSlide, nextSlide) {
        var cnt = slick.options.slidesToScroll;
        var slideNum = (nextSlide === undefined) ? 1 : nextSlide + 1;
        $(this).closest('.js-sliderSliderWrap').find('.js-sliderSliderCounter').html(
            '<span>' + slideNum + '</span><span class="sep"> — </span><span class="all">' + (Math.ceil(slick.slideCount / cnt)) + '</span>'
        );
    });

    $('.js-slider').slick({
        arrows: true,
        centerMode: false,
        slidesToShow: 1,
        adaptiveHeight: true,
        prevArrow: '<button class="arrow prev-arrow"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M14.5 7.03535H15V8.03535H14.5V7.53535V7.03535ZM0.5 8.03535C0.223858 8.03535 0 7.8115 0 7.53535C0 7.25921 0.223858 7.03535 0.5 7.03535V7.53535V8.03535ZM7.03474 0.5V0L8.03474 0V0.5L7.53474 0.5L7.03474 0.5ZM0.810138 7.90359C0.567717 8.03583 0.263996 7.9465 0.131761 7.70408C-0.000475883 7.46166 0.0888472 7.15794 0.331269 7.0257L0.570704 7.46465L0.810138 7.90359ZM8.0348 14.5V15H7.0348V14.5H7.5348H8.0348ZM14.5 7.53535V8.03535L0.570761 8.03535V7.53535V7.03535L14.5 7.03535V7.53535ZM0.570761 7.53535V8.03535H0.5V7.53535V7.03535H0.570761V7.53535ZM7.53474 0.5L8.03474 0.5C8.03474 1.46517 7.51122 2.40874 6.83424 3.23966C6.14729 4.08282 5.24358 4.88117 4.35846 5.56517C3.4704 6.25145 2.58482 6.83499 1.92269 7.24634C1.59115 7.45231 1.31451 7.6158 1.12013 7.72814C1.02292 7.78432 0.946214 7.82775 0.893425 7.85735C0.867028 7.87215 0.846606 7.88349 0.832584 7.89124C0.825573 7.89512 0.820162 7.89809 0.816403 7.90016C0.814524 7.90119 0.813058 7.90199 0.812011 7.90257C0.811488 7.90285 0.811069 7.90308 0.810758 7.90325C0.810601 7.90334 0.810446 7.90342 0.810368 7.90346C0.81024 7.90353 0.810138 7.90359 0.570704 7.46465C0.331269 7.0257 0.331221 7.02573 0.331199 7.02574C0.331226 7.02573 0.33123 7.02572 0.331285 7.02569C0.331397 7.02563 0.331613 7.02552 0.331933 7.02534C0.332573 7.02499 0.333631 7.02441 0.335099 7.0236C0.338035 7.02199 0.342612 7.01947 0.348778 7.01607C0.361109 7.00925 0.379791 6.99887 0.404401 6.98508C0.453625 6.95748 0.526535 6.91621 0.619744 6.86234C0.806212 6.75457 1.07364 6.59655 1.39498 6.39691C2.03861 5.99706 2.89404 5.43305 3.74698 4.77391C4.60288 4.11249 5.44017 3.36754 6.05898 2.60803C6.68775 1.83627 7.03474 1.11779 7.03474 0.5L7.53474 0.5ZM0.570761 7.53535C0.758092 7.07177 0.758235 7.07183 0.758404 7.0719C0.758495 7.07194 0.758692 7.07202 0.758875 7.07209C0.759243 7.07224 0.759716 7.07243 0.760294 7.07267C0.761451 7.07314 0.763028 7.07378 0.765019 7.07459C0.769002 7.07622 0.77464 7.07854 0.781881 7.08153C0.796362 7.08752 0.817256 7.09624 0.844136 7.10764C0.89789 7.13042 0.975623 7.16395 1.07391 7.20785C1.27042 7.29563 1.54951 7.42506 1.88372 7.59332C2.55089 7.92919 3.44389 8.42281 4.34008 9.05202C5.23369 9.67942 6.14794 10.4537 6.84276 11.3556C7.53813 12.2583 8.0348 13.3172 8.0348 14.5H7.5348H7.0348C7.0348 13.6076 6.66095 12.7582 6.05057 11.9659C5.43963 11.1729 4.61287 10.4654 3.76547 9.87045C2.92066 9.27731 2.07265 8.808 1.43406 8.48652C1.1154 8.32609 0.850417 8.20325 0.66608 8.12091C0.573947 8.07976 0.502062 8.04877 0.453804 8.02831C0.429679 8.01808 0.411468 8.01049 0.399595 8.00558C0.39366 8.00312 0.389309 8.00134 0.386597 8.00023C0.385241 7.99967 0.384295 7.99929 0.383764 7.99907C0.383499 7.99896 0.383338 7.9989 0.383282 7.99888C0.383254 7.99886 0.383291 7.99888 0.383277 7.99887C0.38334 7.9989 0.38343 7.99894 0.570761 7.53535Z" fill="white"/> </svg></button>',
        nextArrow: '<button class="arrow next-arrow"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.5 7.03535H0L0 8.03535H0.5L0.5 7.53535L0.5 7.03535ZM14.5 8.03535C14.7761 8.03535 15 7.8115 15 7.53535C15 7.25921 14.7761 7.03535 14.5 7.03535V7.53535V8.03535ZM7.96526 0.5V0L6.96526 0V0.5L7.46526 0.5L7.96526 0.5ZM14.1899 7.90359C14.4323 8.03583 14.736 7.9465 14.8682 7.70408C15.0005 7.46166 14.9112 7.15794 14.6687 7.0257L14.4293 7.46465L14.1899 7.90359ZM6.9652 14.5V15H7.9652V14.5H7.4652H6.9652ZM0.5 7.53535L0.5 8.03535L14.4292 8.03535V7.53535V7.03535L0.5 7.03535L0.5 7.53535ZM14.4292 7.53535V8.03535H14.5V7.53535V7.03535H14.4292V7.53535ZM7.46526 0.5L6.96526 0.5C6.96526 1.46517 7.48878 2.40874 8.16576 3.23966C8.85271 4.08282 9.75642 4.88117 10.6415 5.56517C11.5296 6.25145 12.4152 6.83499 13.0773 7.24634C13.4088 7.45231 13.6855 7.6158 13.8799 7.72814C13.9771 7.78432 14.0538 7.82775 14.1066 7.85735C14.133 7.87215 14.1534 7.88349 14.1674 7.89124C14.1744 7.89512 14.1798 7.89809 14.1836 7.90016C14.1855 7.90119 14.1869 7.90199 14.188 7.90257C14.1885 7.90285 14.1889 7.90308 14.1892 7.90325C14.1894 7.90334 14.1896 7.90342 14.1896 7.90346C14.1898 7.90353 14.1899 7.90359 14.4293 7.46465C14.6687 7.0257 14.6688 7.02573 14.6688 7.02574C14.6688 7.02573 14.6688 7.02572 14.6687 7.02569C14.6686 7.02563 14.6684 7.02552 14.6681 7.02534C14.6674 7.02499 14.6664 7.02441 14.6649 7.0236C14.662 7.02199 14.6574 7.01947 14.6512 7.01607C14.6389 7.00925 14.6202 6.99887 14.5956 6.98508C14.5464 6.95748 14.4735 6.91621 14.3803 6.86234C14.1938 6.75457 13.9264 6.59655 13.605 6.39691C12.9614 5.99706 12.106 5.43305 11.253 4.77391C10.3971 4.11249 9.55983 3.36754 8.94102 2.60803C8.31225 1.83627 7.96526 1.11779 7.96526 0.5L7.46526 0.5ZM14.4292 7.53535C14.2419 7.07177 14.2418 7.07183 14.2416 7.0719C14.2415 7.07194 14.2413 7.07202 14.2411 7.07209C14.2408 7.07224 14.2403 7.07243 14.2397 7.07267C14.2385 7.07314 14.237 7.07378 14.235 7.07459C14.231 7.07622 14.2254 7.07854 14.2181 7.08153C14.2036 7.08752 14.1827 7.09624 14.1559 7.10764C14.1021 7.13042 14.0244 7.16395 13.9261 7.20785C13.7296 7.29563 13.4505 7.42506 13.1163 7.59332C12.4491 7.92919 11.5561 8.42281 10.6599 9.05202C9.76631 9.67942 8.85206 10.4537 8.15724 11.3556C7.46187 12.2583 6.9652 13.3172 6.9652 14.5H7.4652H7.9652C7.9652 13.6076 8.33905 12.7582 8.94943 11.9659C9.56037 11.1729 10.3871 10.4654 11.2345 9.87045C12.0793 9.27731 12.9274 8.808 13.5659 8.48652C13.8846 8.32609 14.1496 8.20325 14.3339 8.12091C14.4261 8.07976 14.4979 8.04877 14.5462 8.02831C14.5703 8.01808 14.5885 8.01049 14.6004 8.00558C14.6063 8.00312 14.6107 8.00134 14.6134 8.00023C14.6148 7.99967 14.6157 7.99929 14.6162 7.99907C14.6165 7.99896 14.6167 7.9989 14.6167 7.99888C14.6167 7.99886 14.6167 7.99888 14.6167 7.99887C14.6167 7.9989 14.6166 7.99894 14.4292 7.53535Z" fill="white"/> </svg></button>',
        appendArrows: $('.js-sliderSliderWrap').find('.js-sliderSliderArrows')
    });
    /*slider*/

    /*wpcf7 thankyou*/
    document.addEventListener('wpcf7mailsent', function (event) {
        $('.js-modalWindow').removeClass('active');
        $('.js-modalContact').addClass('active');
        $('body').css('overflow', 'hidden');
    }, false);
    $('.js-modalContactCls').click(function(){
        $('.js-modalContact').removeClass('active');
        $('body').css('overflow', '');
    });
    /*wpcf7 thankyou*/

    /*scroll sidebar*/
    /*$(window).on('load resize', function(){
        if ($('.js-pageTextSide').length > 0) {
            if ($(window).width() > 991) {
                var singleSidebarTop = $('.js-pageTextSide').offset().top;
                var singleSidebarRailTop = $('.js-pageTextSideRail').offset().top;
                var headerOffset = $('header').outerHeight();
                var windowTop = $(window).scrollTop() + headerOffset + 30;

                var singleSidebarH = $('.js-pageTextSide').outerHeight();
                var singleSidebarMenuH = $('.js-pageTextSideMenu').outerHeight();
                if (singleSidebarH > singleSidebarMenuH) {
                    $('.js-pageTextSideRail').height(singleSidebarH - singleSidebarMenuH);
                }
                var singleSidebarRailH = $('.js-pageTextSideRail').outerHeight();
                var singleSidebarRailBottom = singleSidebarRailTop + singleSidebarRailH;

                $(window).scroll(function(){
                    windowTop = $(window).scrollTop() + headerOffset + 30;
                    if (windowTop > singleSidebarTop && windowTop < singleSidebarRailBottom) {
                        $('.js-pageTextSideMenu').css('top', windowTop - singleSidebarTop)
                    } else if (windowTop > singleSidebarTop && windowTop >= singleSidebarRailBottom) {
                        $('.js-pageTextSideMenu').css('top', '100%')
                    } else if (windowTop <= singleSidebarTop) {
                        $('.js-pageTextSideMenu').css('top', '0')
                    }
                })
            } else {
                $('.js-pageTextSideRail').css('height', 'auto')
            }
        }
    })*/
    /*scroll sidebar*/

    /*page faq*/
    /*$('.js-pageFaqCat').click(function(){
        var id = $(this).data('id');
        if (id === 'all') {
            $('.js-pageFaqListItem').slideDown();
        } else if ($('.js-pageFaqCat.active').data('id') === 'all') {
            $('.js-pageFaqListItem:not([data-id="'+id+'"])').slideUp();
            $('.js-pageFaqListItem:not([data-id="'+id+'"])').removeClass('opened');
        } else {
            $('.js-pageFaqListItem').slideUp();
            $('.js-pageFaqListItem').removeClass('opened');
            $('.js-pageFaqListItem[data-id="'+id+'"]').slideDown();
            $('.js-pageFaqListItem[data-id="'+id+'"]').addClass('opened');
        }
        $('.js-pageFaqCat').removeClass('active')
        $(this).addClass('active')


        $('.js-pageFaqListBurg').removeClass('active')
        $('.js-pageFaqListBurgWrap').removeClass('active')
        $('.js-pageFaqListBurgTxt').slideUp()
        $('.js-pageFaqListItem.opened .js-pageFaqListBurg').eq(0).addClass('active')
        $('.js-pageFaqListItem.opened .js-pageFaqListBurgWrap').eq(0).addClass('active')
        $('.js-pageFaqListItem.opened .js-pageFaqListBurgTxt').eq(0).slideDown()
    })
    $('.js-pageFaqListBurg').click(function(){
        $('.js-pageFaqListBurg').removeClass('active')
        $('.js-pageFaqListBurgWrap').removeClass('active')
        $('.js-pageFaqListBurgTxt').slideUp()
        $(this).addClass('active')
        $(this).closest('.js-pageFaqListBurgWrap').addClass('active')
        $(this).siblings('.js-pageFaqListBurgTxt').slideDown()
    })*/
    /*page faq*/

    /*halo orbs*/
    // taches colorées des fonds : elles flottent lentement et glissent au défilement (effet de profondeur).
    // Position calculée en proportion de la fenêtre : indépendant du zoom de body. Rien ne bouge si l'utilisateur limite les animations.
    $(function () {
        var sel = '.main-second, .main-vals, .main-techs, .main-equipe, .main-cons, .page-cabinet-techs, .page-family-cases, ' +
            '.page-parc-steps, .single_trait-content, .page-hon-main, .page-faq-main, .page-doctor-main, .page-equipe-doc, ' +
            '.page-equipe-team, .page-cons-main, .tax_trait-intro, .tax_trait-posts';
        var sections = document.querySelectorAll(sel);
        if (!sections.length) return;
        var layers = [];
        sections.forEach(function (sec, i) {
            var wrap = document.createElement('div');
            var count = sec.offsetHeight > 1100 ? 3 : 2;
            wrap.className = 'halo-orbs' + (i % 2 ? ' halo-orbs--alt' : '');
            wrap.setAttribute('aria-hidden', 'true');
            for (var k = 0; k < count; k++) {
                var orb = document.createElement('span');
                orb.className = 'halo-orb';
                wrap.appendChild(orb);
            }
            sec.appendChild(wrap);
            layers.push({el: wrap, vis: true});
        });
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        var ticking = false;
        function update() {
            ticking = false;
            var vh = window.innerHeight;
            layers.forEach(function (l) {
                if (!l.vis) return;
                var r = l.el.getBoundingClientRect();
                var p = ((r.top + r.height / 2) - vh / 2) / (vh / 2 + r.height / 2);
                p = Math.max(-1, Math.min(1, p));
                l.el.style.setProperty('--halo-p', p.toFixed(3));
            });
        }
        function request() {
            if (!ticking) {
                ticking = true;
                window.requestAnimationFrame(update);
            }
        }
        if ('IntersectionObserver' in window) {
            var io = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    layers.forEach(function (l) {
                        if (l.el === entry.target) l.vis = entry.isIntersecting;
                    });
                });
                request();
            }, {rootMargin: '200px 0px'});
            layers.forEach(function (l) { io.observe(l.el); });
        }
        window.addEventListener('scroll', request, {passive: true});
        window.addEventListener('resize', request);
        update();
    });
    /*halo orbs*/

}( jQuery ) );